var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumSlotWon = function SvgNumSlotWon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 76 90"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#num_slot_won_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#num_slot_won_svg__b)",
    d: "M25.343 39.48q-10.032 0-15.808-3.572-5.7-3.572-5.7-11.324 0-7.676 5.776-11.248 5.776-3.648 15.732-3.648 10.032 0 15.808 3.648 5.776 3.571 5.776 11.248 0 7.752-5.776 11.324T25.343 39.48m0-10.108q4.865 0 6.764-1.14t1.9-3.648-1.9-3.648-6.764-1.14q-4.787 0-6.764 1.14-1.9 1.14-1.9 3.648t1.9 3.648q1.977 1.14 6.764 1.14M2.24 42.14h51.756v11.172H32.563v6.916H18.2v-6.916H2.24zm55.556-11.932h-8.588V18.2h8.588V8.7H72.16v52.82H57.795zM7.103 63.04h14.592v6.612h50.996V81.28H7.103z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "num_slot_won_svg__b",
    x1: 38,
    x2: 38,
    y1: 0,
    y2: 91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F34"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "num_slot_won_svg__a",
    width: 71.948,
    height: 74.076,
    x: 1.239,
    y: 7.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.496,
    dy: 0.496
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_299_12656"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_299_12656",
    result: "effect2_innerShadow_299_12656"
  })))));
};
export default SvgNumSlotWon;